import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getProjects, getProjectForms } from '../../services/projectService';
import { getForm, getForms, getTabForms, getFormWidgets } from '../../services/formService';
import { WidgetTypes } from '../../constants/QuestionTypes';
import _ from 'lodash';
import { stripTags } from '../common/commonFuncs';
import CustomLoader from '../common/Loader';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import { logActivity } from '../../services/utilService';
import Select from "react-select";


class AddVariables extends Component {
    constructor(props) {
        super(props);

        this.state = {
            preloadData: this.props.preloadData ? this.props.preloadData : undefined,
            loading: true,
            formSelected: {},
            selectedFormWidgetsList: [],
            vblTypes: ['Text', 'Numeric', 'Date/Time', 'Categorical', 'Multiple Choice'],
            vblSelected: {}
        };
    }

    componentDidMount() {
        this.inputChangeEvent = this.inputChangeEvent.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.loadForms().
            then(this.loadFormWidgets).
            then(this.fillPreloadData).
            then(this.setState({ loading: false }));
    }

    loadForms = async () => {
        const { data: forms } = await getTabForms(9);
        this.setState({ forms });
    };

    loadFormWidgets = async () => {
        let { data: widgets } = await getFormWidgets(2);
        widgets = widgets.filter((w) => {
            if (w.Widget_Type_ID === WidgetTypes.QA) {
                w['label'] = stripTags(w.Question_Text) + ' (#' + (w.Widget_ID) + ')';
                w['value'] = w.Widget_ID;
                return w;
            }
        });
        widgets.map((w, wIdx) => {
            w['label'] = 'Q' + (wIdx + 1) + '. ' + w['label'];
            return w;
        });
        this.setState({ widgets });
        //console.log('widgets', widgets);
    };

    fillPreloadData = async () => {
        if (this.state.preloadData) {
            let preloadDataObj = this.state.preloadData,
                vblSelected = {
                    'vblID': preloadDataObj[0],
                    'vblName': preloadDataObj[1],
                    'vblDesc': preloadDataObj[2],
                    'formID': preloadDataObj[3],
                    'projectName': preloadDataObj[4]
                };
            this.setState({ vblSelected });
        }
        Promise.resolve('success');
    }

    inputChangeEvent(e) {
        let vblSelected = this.state.vblSelected, inputData = e.target;
        vblSelected[inputData.name] = inputData.value;
        this.setState({ vblSelected });
    }

    clearFields() {
        let vblSelected = this.state.vblSelected;
        vblSelected['vblName'] = '';
        vblSelected['vblDesc'] = '';
        vblSelected['formID'] = this.state.projects ? this.state.projects[0]['Form_ID'] : 0;
        this.setState({ vblSelected });
    }

    handleSave() {
        let vblSelected = this.state.vblSelected, isvalid = Object.keys(vblSelected).length > 0;
        if (Object.keys(vblSelected).length > 0) {
            /* Form Validation */
            for (const key in vblSelected) {
                if (vblSelected[key] !== '' && vblSelected[key] !== undefined) { continue; }
                else {
                    if (key !== 'vblDesc') {
                        isvalid = false;
                        break;
                    }
                }
            }
            if (isvalid) {
                try {
                    //API to save vbl
                    //console.log(vblSelected);

                    let data = {};
                    if (typeof data === 'string') {
                        throw new Error('error');
                    }
                    else {
                        toaster('success', 'vbl Saved successfully.')
                    }
                }
                catch (e) {
                    toaster('error', 'Oops! Cannot Save form at this time. Please try again later.')
                }
            }
            else {
                toaster('warning', 'Please fill required Details for saving!')
            }
        }
        else {
            toaster('warning', 'Please fill required Details for saving!')
        }
    }

    render() {
        const { forms, widgets, vblTypes, vblSelected } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading; }
            else {
                return (
                    <React.Fragment>
                        <div className='card card-header-actions'>
                            <div className='card-body'>
                                <div className='align-items-center justify-content-between'>
                                    <h4 className='ml-3'>Add Variable</h4>
                                    <div class='row ml-2 mt-4'>
                                        <span className='col col-md-2'>Name</span>
                                        <input type='search' id='' name='vblName' className='col col-md-3 form-inline form-control' value={vblSelected.vblName} onChange={this.inputChangeEvent} />
                                    </div><br />
                                    <div class='row ml-2'>
                                        <span className='col col-md-2 align-top'>DataType</span>
                                        <select name='vblType' className='btn btn-lg dropdown-toggle border col col-md-3' value={vblSelected.vblType} onChange={this.inputChangeEvent}>
                                            {
                                                vblTypes.map((v, vIdx) => {
                                                    return (<option value={vIdx + 1}>{v}</option>);
                                                })
                                            }
                                        </select>
                                    </div><br />
                                    <div class='row ml-2'>
                                        <span className='col col-md-2 align-top'>Description</span>
                                        <input type='search' id='' name='vblDesc' className='col col-md-3 form-inline form-control' value={vblSelected.vblDesc} onChange={this.inputChangeEvent} />
                                    </div><br />
                                    <div class='row ml-2'>
                                        <span className='col col-md-2'>Select Form</span>
                                        <select name='formID' className='btn btn-lg dropdown-toggle border col col-md-3' value={vblSelected.formID} onChange={this.inputChangeEvent}>
                                            {
                                                forms.map((form) => {
                                                    return (<option value={form.Form_ID}>{form.Form_Name}</option>);
                                                })
                                            }
                                        </select>
                                    </div><br />
                                    <div class='row ml-2'>
                                        <span className='col col-md-2'>Select Question(s)</span>
                                        <Select name='widgetID' isMulti closeMenuOnSelect={false} className='col col-md-3 ml-n2' options={widgets} value={vblSelected.widgetID} onChange={this.inputChangeEvent}/>
                                    </div>
                                    <br />
                                    <div class='row ml-2'>
                                        <span className='col col-md-2 align-top'>Condition(s)</span>
                                        <textarea className='col col-md-3 form-inline form-control' id='' name='vblCondition' rows={5} value={vblSelected.vblCondition} onChange={this.inputChangeEvent} />
                                    </div><br />
                                    <div class='row ml-2'>
                                        <button className='btn btn-primary ml-2' onClick={this.handleSave}>Add</button>
                                        <button className='btn btn-success ml-2' onClick={this.clearFields}>Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ToastContainer />
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Add Variable Component: ', e);
            return (loading);
        }
    }
}

export default AddVariables;